import { getData as apiGetData } from 'api/Api'
import { mapActivityData } from 'utils/activities'
import {
  addArray as addActivitiesArray,
  setLoadStatus,
  setLastLoadedId
} from '../redux/activities'

type Payload = {
  cardId: number
}

type ActivitiesArgs = {
  tagName: string
  olderThanId?: number
}

export default (payload: Payload) => async (dispatch, getState) => {
  const { cardId } = payload

  dispatch(setLoadStatus({
    cardId,
    isLoading: true,
    isLoaded: false,
  }))

  const state = getState()

  const lastLoadedId = state['view-card'].activities[cardId].lastLoadedId

  const args: ActivitiesArgs = {
    tagName: 'card-' + cardId
  }

  if (lastLoadedId) {
    args.olderThanId = lastLoadedId
  }

  try {
    const { Activities } = await apiGetData('Activities', args)

    const activities: any[] = []
    let newLastLoadedId = null

    Activities.forEach(Activity => {
      const activity = mapActivityData(Activity)

      activities.push(activity)

      if (lastLoadedId === null || lastLoadedId > activity.id) {
        newLastLoadedId = activity.id
      }
    })

    const batchedActions: any[] = [
      addActivitiesArray({
        cardId,
        array: activities,
      }),
      setLoadStatus({
        cardId,
        isLoading: false,
        isLoaded: Activities.length < 20
      })
    ]

    if (newLastLoadedId !== null) {
      batchedActions.push(setLastLoadedId({
        cardId,
        lastLoadedId: newLastLoadedId
      }))
    }

    dispatch(batchedActions)
  } catch (error) {
    dispatch(setLoadStatus({
      cardId,
      isLoading: false,
      isLoaded: false,
    }))
  }
}
